import React, { useState, useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import thirdbg from "./assets/bg3.webp";
import axios from "axios";
import barcode1 from "./assets/barcode1.webp";
import barcode2 from "./assets/barcode2.webp";
import rathYatraBanner from "./NewBanner.jpg";
import { Helmet } from "react-helmet-async";
import BannerImgDesk from "./assets/NARASHIMA.jpg";
import puriComes from "./assets/images/puriComes.jpeg";
import img2 from "./assets/images/festival2.png";
import img3 from "./assets/images/festival3.png";
import img4 from "./assets/images/festival4.png";
import img5 from "./assets/images/festival5.png";
import img6 from "./assets/images/festival6.png";
import sixKm from "./assets/images/sixKm.jpeg";
import slider1 from "./assets/images/slider1.jpeg";
import slider2 from "./assets/images/slider2.jpeg";
import slider3 from "./assets/images/slider3.jpeg";
import slider4 from "./assets/images/slider4.jpeg";
import bookRecord from "./assets/images/bookRecord.jpeg";
import RYMainHeading from "./assets/images/RYMainHeading.png";
import mainheading from "./assets/images/rathYatraHeading.png";
import Ecstatic from "./assets/images/Ecstatic.jpeg";
import beAvolenter from "./assets/images/beAvolenter.jpeg";
import performance from "./assets/images/Traditional Performances.jpeg";
import Parade from "./assets/images/Parade.jpeg";
import chappanBhog from "./assets/images/chappanBhog.jpeg";
import AithenticFestival from "./assets/images/authantic jagnanth faestival.jpeg";
import marchandise from "./assets/images/marchandise.jpeg";
import pullRath from "./assets/images/pull-the-rath.jpeg";
import globalKirtan from "./assets/images/globalKirtan.jpeg";
import record from "./assets/images/record.png";
import { PiFlowerLotus } from "react-icons/pi";
import { FaOm } from "react-icons/fa";
import { FaMusic } from "react-icons/fa";
import { FaBookOpen } from "react-icons/fa6";
import { GiBabyfootPlayers } from "react-icons/gi";
import { FaFeatherAlt } from "react-icons/fa";
import { FaPlateWheat } from "react-icons/fa6";
import { FaRegImages } from "react-icons/fa6";
import { PiFlowerLotusFill } from "react-icons/pi";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import RathNavbar from "./RathNavbar";
import "./yatraPage.css";
// import "./rathYatra.css";

const SliderData = [
  {
    id: 1,
    img: record,
  },
  {
    id: 2,
    img: slider1,
  },
  {
    id: 3,
    img: slider2,
  },
  {
    id: 4,
    img: slider3,
  },
  {
    id: 5,
    img: slider4,
  },
];

const cardData = [
  {
    imgSrc: Ecstatic,
    imgAlt: "Ecstatic Kirtans",
    title: "Ecstatic Kirtans & Chants",
    description:
      "Experience the bliss of ecstatic kirtans, traditional drumming, and Vedic chants.",
    contentStyle: { color: "white" },
  },
  {
    imgSrc: Parade,
    imgAlt: "Cultural Tableau Parade",
    title: "Cultural Tableau Parade",
    description:
      "Witness a stunning cultural tableau parade showcasing Vedic epics and regional traditions.",
  },
  {
    imgSrc: performance,
    imgAlt: "Traditional Performances",
    title: "Traditional Performances",
    description:
      "Enjoy colorful groups performing traditional dances, plays, and bhakti dramas.",
    contentStyle: {},
  },
];

const RathYatraPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    annadaanSeva: false,
    isFullPlateChecked: false,
    isDonneCupChecked: false,
    selectedFullPlateAmount: null,
    customFullPlateAmount: "",
    selectedDonneCupAmount: null,
    customDonneCupAmount: "",
    vastraAlankarSeva: false,
    chappanBhogSeva: false,
    pushpaMalaSeva: false,
    yejnaSeva: false,
    // mandirAlnkarnaSeva: false,
    donateByWish: false,

    sevaDate: "",
    honoureeName: "",
    relationship: "",
    donorName: "",
    email: "",
    mobile: "",
    dob: "",
    receive80G: false,
    panNumber: "",
    receiveMahaPrasadam: false,

    selectedAnnadaanAmount: false,
    selectedvastraAlankarAmount: false,
    selectedChappanBhogAmount: false,
    selectedPushpaMalaAmount: false,
    selectedYejnaAmount: false,
    // selectedMandirAlnkarnaAmount: false,
    selectedDonationAmount: null,

    customAnnadaanAmount: "",
    customvastraAlankarAmount: "",
    customChappanBhogAmount: "",
    customPushpaMalaAmount: "",
    customYejnaAmount: "",
    // customMandirAlnkarnaAmount: "",
    customDonationAmount: "",

    mahaPrasadamDetails: {
      doorNumber: "",
      houseName: "",
      streetName: "",
      area: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
    },
  });

  const [errors, setErrors] = useState({});
  const [show80GDetails, setShow80GDetails] = useState(false);
  const [showMahaPrasadamDetails, setShowMahaPrasadamDetails] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
      };

      if (name === "customAnnadaanAmount" && value) {
        updatedData.selectedAnnadaanAmount = parseFloat(value);
      } else if (name === "customvastraAlankarAmount" && value) {
        updatedData.selectedvastraAlankarAmount = parseFloat(value);
      } else if (name === "customChappanBhogAmount" && value) {
        updatedData.selectedChappanBhogAmount = parseFloat(value);
      } else if (name === "customPushpaMalaAmount" && value) {
        updatedData.selectedPushpaMalaAmount = parseFloat(value);
      } else if (name === "customYejnaAmount" && value) {
        updatedData.selectedYejnaAmount = parseFloat(value);
      } else if (name === "customDonationAmount" && value) {
        updatedData.selectedDonationAmount = parseFloat(value);
      }

      return updatedData;
    });
  };

  const handle80GCheckboxChange = (e) => {
    setShow80GDetails(e.target.checked);
    handleInputChange(e);
  };

  const handleMahaPrasadamCheckboxChange = (e) => {
    setShowMahaPrasadamDetails(e.target.checked);
    handleInputChange(e);
  };
  const handleAmountSelect = (section, amount) => {
    setFormData((prevData) => {
      switch (section) {
        case "annadaan":
          return {
            ...prevData,
            selectedAnnadaanAmount:
              prevData.selectedAnnadaanAmount === amount ? null : amount,
            customAnnadaanAmount: "",
            selectedFullPlateAmount: null,
            customFullPlateAmount: "",
            selectedDonneCupAmount: null,
            customDonneCupAmount: "",
          };
        case "fullPlate":
          return {
            ...prevData,
            selectedFullPlateAmount:
              prevData.selectedFullPlateAmount === amount ? null : amount,
            customFullPlateAmount: "",
            selectedAnnadaanAmount: null,
            customAnnadaanAmount: "",
          };
        case "donneCup":
          return {
            ...prevData,
            selectedDonneCupAmount:
              prevData.selectedDonneCupAmount === amount ? null : amount,
            customDonneCupAmount: "",
            selectedAnnadaanAmount: null,
            customAnnadaanAmount: "",
          };
        case "vastraAlankar":
          return {
            ...prevData,
            selectedvastraAlankarAmount:
              prevData.selectedvastraAlankarAmount === amount ? null : amount,
            customvastraAlankarAmount: "",
          };
        case "chappanBhog":
          return {
            ...prevData,
            selectedChappanBhogAmount:
              prevData.selectedChappanBhogAmount === amount ? null : amount,
            customChappanBhogAmount: "",
          };
        case "pushpaMala":
          return {
            ...prevData,
            selectedPushpaMalaAmount:
              prevData.selectedPushpaMalaAmount === amount ? null : amount,
            customPushpaMalaAmount: "",
          };
        case "yejna":
          return {
            ...prevData,
            selectedYejnaAmount:
              prevData.selectedYejnaAmount === amount ? null : amount,
            customYejnaAmount: "",
          };

        default:
          return prevData;
      }
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.donorName) newErrors.donorName = "Donor name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.mobile) newErrors.mobile = "Mobile number is required";
    if (!formData.dob) newErrors.dob = "Date of birth is required";
    if (formData.receive80G && !formData.panNumber)
      newErrors.panNumber = "PAN number is required for 80G certificate";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getTotalAmount = () => {
    const annadaanAmount =
      formData.selectedAnnadaanAmount ||
      parseFloat(formData.customAnnadaanAmount) ||
      0;
    const fullPlateAmount =
      formData.selectedFullPlateAmount ||
      parseFloat(formData.customFullPlateAmount) ||
      0;
    const donneCupAmount =
      formData.selectedDonneCupAmount ||
      parseFloat(formData.customDonneCupAmount) ||
      0;
    const vastraAlankarAmount =
      formData.selectedvastraAlankarAmount ||
      parseFloat(formData.customvastraAlankarAmount) ||
      0;
    const chappanBhogAmount =
      formData.selectedChappanBhogAmount ||
      parseFloat(formData.customChappanBhogAmount) ||
      0;
    const pushpaMalaAmount =
      formData.selectedPushpaMalaAmount ||
      parseFloat(formData.customPushpaMalaAmount) ||
      0;
    const yejnaAmount =
      formData.selectedYejnaAmount ||
      parseFloat(formData.customYejnaAmount) ||
      0;

    const donationByWishAmount =
      formData.selectedDonationAmount ||
      parseFloat(formData.customDonationAmount) ||
      0;

    return (
      annadaanAmount +
      fullPlateAmount +
      donneCupAmount +
      vastraAlankarAmount +
      chappanBhogAmount +
      pushpaMalaAmount +
      yejnaAmount +
      donationByWishAmount
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const totalAmount = getTotalAmount();
    let isFormDataStored = false;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/payment/create-order`,
        {
          amount: totalAmount,
          currency: "INR",
        }
      );

      const order = response.data;
      let sevaDescription = "Donation Payment";

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: totalAmount * 100,
        currency: "INR",
        name: "ISKCON Amaravati Rath Yatra Donation",
        description: sevaDescription,
        order_id: order.id,
        notes: {
          donorName: formData.donorName,
          donorPhoneNumber: formData.mobile,
          donorEmail: formData.email,
        },
        handler: async function (response) {
          try {
            const verificationResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                donationDetails: { ...formData, amount: totalAmount },
              }
            );

            if (verificationResponse.data.success) {
              alert("Payment Successful!");
              if (!isFormDataStored) {
                await storeFormData("Payment Successful");
                isFormDataStored = true;
              }
            }
          } catch (err) {
            console.error(err);
            alert("Payment verification failed");
            if (!isFormDataStored) {
              await storeFormData("Payment Failed");
              isFormDataStored = true;
            }
          }
        },
        prefill: {
          name: formData.donorName,
          email: formData.email,
          contact: formData.mobile,
        },
        theme: { color: "#C61D21" },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

      paymentObject.on("payment.failed", async function (response) {
        alert("Payment Failed: " + response.error.description);
        if (!isFormDataStored) {
          await storeFormData("Payment Failed");
          isFormDataStored = true;
        }
      });
    } catch (error) {
      console.error("Error initiating payment:", error);
      alert("Failed to initiate payment. Please try again.");
      if (!isFormDataStored) {
        await storeFormData("Payment Failed");
        isFormDataStored = true;
      }
    }
  };

  const storeFormData = async (paymentStatus) => {
    const totalDonationAmount = getTotalAmount();

    // Prepare data in the format expected by your Apps Script
    const formDataToSend = new URLSearchParams();

    // Add all fields to the form data
    formDataToSend.append("paymentStatus", paymentStatus);

    formDataToSend.append("annadaanSeva", formData.annadaanSeva ? "Yes" : "No");
    formDataToSend.append(
      "fullPlateAmount",
      formData.selectedFullPlateAmount || formData.customFullPlateAmount || 0
    );
    formDataToSend.append(
      "donneCupAmount",
      formData.selectedDonneCupAmount || formData.customDonneCupAmount || 0
    );
    formDataToSend.append(
      "vastraAlankarSeva",
      formData.vastraAlankarSeva ? "Yes" : "No"
    );
    formDataToSend.append(
      "vastraAlankarAmount",
      formData.selectedvastraAlankarAmount ||
        formData.customvastraAlankarAmount ||
        0
    );
    formDataToSend.append(
      "chappanBhogSeva",
      formData.chappanBhogSeva ? "Yes" : "No"
    );
    formDataToSend.append(
      "chappanBhogAmount",
      formData.selectedChappanBhogAmount ||
        formData.customChappanBhogAmount ||
        0
    );
    formDataToSend.append(
      "pushpaMalaSeva",
      formData.pushpaMalaSeva ? "Yes" : "No"
    );
    formDataToSend.append(
      "pushpaMalaAmount",
      formData.selectedPushpaMalaAmount || formData.customPushpaMalaAmount || 0
    );
    formDataToSend.append("yejnaSeva", formData.yejnaSeva ? "Yes" : "No");
    formDataToSend.append(
      "yejnaAmount",
      formData.selectedYejnaAmount || formData.customYejnaAmount || 0
    );

    formDataToSend.append("donateByWish", formData.donateByWish ? "Yes" : "No");
    formDataToSend.append(
      "donationByWishAmount",
      formData.selectedDonationAmount || formData.customDonationAmount || 0
    );

    formDataToSend.append("totalDonationAmount", totalDonationAmount);
    formDataToSend.append("sevaDate", formData.sevaDate || "");
    formDataToSend.append("honoureeName", formData.honoureeName || "");
    formDataToSend.append("relationship", formData.relationship || "");
    formDataToSend.append("donorName", formData.donorName);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("mobile", formData.mobile);
    formDataToSend.append("dob", formData.dob);
    formDataToSend.append("receive80G", formData.receive80G ? "Yes" : "No");
    formDataToSend.append(
      "panNumber",
      formData.receive80G ? formData.panNumber : ""
    );
    formDataToSend.append(
      "receiveMahaPrasadam",
      formData.receiveMahaPrasadam ? "Yes" : "No"
    );
    formDataToSend.append(
      "doorNumber",
      formData.mahaPrasadamDetails.doorNumber || ""
    );
    formDataToSend.append(
      "houseName",
      formData.mahaPrasadamDetails.houseName || ""
    );
    formDataToSend.append(
      "streetName",
      formData.mahaPrasadamDetails.streetName || ""
    );
    formDataToSend.append("area", formData.mahaPrasadamDetails.area || "");
    formDataToSend.append(
      "country",
      formData.mahaPrasadamDetails.country || ""
    );
    formDataToSend.append("state", formData.mahaPrasadamDetails.state || "");
    formDataToSend.append("city", formData.mahaPrasadamDetails.city || "");
    formDataToSend.append(
      "pincode",
      formData.mahaPrasadamDetails.pincode || ""
    );

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbz4gmEOKEuQeVbSGEtR4HaB3lVUisx54xmPRLvQlF3grMHvzR9rt6SMY4vKHwQ8sXur/exec",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formDataToSend.toString(),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      console.log("Data stored successfully in Google Sheets");
      return true;
    } catch (error) {
      console.error("Error storing data:", error);
      alert(
        "An error occurred while storing your donation details. Please try again."
      );
      return false;
    }
  };
  const EventCard = ({ Image, title, fullWidth = false }) => (
    <div
      className={`bg-white  rounded-lg overflow-hidden shadow-lg transition-transform duration-300 hover:scale-105 ${
        fullWidth ? "md:col-span-2" : ""
      }`}
    >
      {/* Image container - full width with increased height */}
      <div className="w-full h-64 overflow-hidden">
        {" "}
        {/* Changed from h-48 to h-64 */}
        <img src={Image} alt="" className="w-full h-full object-cover" />
      </div>

      {/* Title with red background - reduced padding */}
      <div className="p-2 bg-[#C61D21] h-full">
        {" "}
        {/* Changed from p-4 to p-2 */}
        <h3 className="text-lg font-bold text-center text-white">{title}</h3>
      </div>
    </div>
  );

  const eventHighlights = [
    {
      Image: puriComes,
      title: "Classical rhythms before lord",
    },
    {
      Image: bookRecord,
      title: "Commemorating divine presence",
    },
    {
      Image: globalKirtan,
      title: " Global Kirtans",
    },
    {
      Image: sixKm,
      title: "6 km Spiritual Procession",
    },
    {
      Image: pullRath,
      title: "Pull the Rath",
      fullWidth: false,
    },
    {
      Image: AithenticFestival,
      title: "Authentic Jagannath Festival",
      fullWidth: false,
    },
  ];

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const [copiedText, setCopiedText] = useState(null);
  const copyToClipboard = async (text, id) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
        setCopiedText(id);
        setTimeout(() => setCopiedText(null), 2000);
      } else {
        alert("Copy functionality is not supported in this browser.");
      }
    } catch (error) {
      console.error("Failed to copy text: ", error);
      alert("Failed to copy. Please try again.");
    }
  };
  const [current, setCurrent] = useState(0);
  const length = SliderData.length;
  const timeoutRef = useRef(null);
  const sliderRef = useRef(null);

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const startAutoplay = () => {
    timeoutRef.current = setTimeout(() => {
      nextSlide();
    }, 4000);
  };

  // Autoplay logic
  useEffect(() => {
    startAutoplay();

    const slider = sliderRef.current;

    const handleMouseEnter = () => {
      resetTimeout();
    };

    const handleMouseLeave = () => {
      startAutoplay();
    };

    if (slider) {
      slider.addEventListener("mouseenter", handleMouseEnter);
      slider.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      resetTimeout();
      if (slider) {
        slider.removeEventListener("mouseenter", handleMouseEnter);
        slider.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, [current, length]);

  if (!Array.isArray(SliderData) || SliderData.length <= 0) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>Amaravati Rath Yatra 2025 | ISKCON Vijayawada</title>
        <meta
          name="description"
          content="Celebrate Narasimha Chaturdashi 2025 with ISKCON Vijayawada! Discover the significance of Lord Narasimhadeva’s appearance, puja rituals, and how to participate in the festival."
        />
        <meta
          name="keywords"
          content="ISKCON Vijayawada Narasimha Chaturdashi, Narasimha Chaturdashi ISKCON Vijayawada, Narasimha Jayanti ISKCON, Narasimha Chaturdashi celebrations at ISKCON Vijayawada, Narasimha Chaturdashi pooja ISKCON Vijayawada, ISKCON Vijayawada festivals, Lord Narasimha festival ISKCON, Narasimha Chaturdashi 2025 ISKCON, Narasimha Jayanti 2025 Vijayawada, Narasimha Chaturdashi puja ISKCON Vijayawada, Lord Narasimha appearance day ISKCON, Narasimha Chaturdashi ritual Vijayawada, ISKCON spiritual events Vijayawada, Narasimha Chaturdashi significance ISKCON, Narasimha avatar celebration ISKCON"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Narasimha Chaturdashi 2025 – Significance, Puja, and Celebrations | ISKCON Vijayawada"
        />
        <meta
          property="og:description"
          content="Celebrate Narasimha Chaturdashi 2025 with ISKCON Vijayawada! Discover the significance of Lord Narasimhadeva’s appearance, puja rituals, and how to participate in the festival."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/NarasimhaChaturdashi"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Narasimha Chaturdashi 2025 – Significance, Puja, and Celebrations | ISKCON Vijayawada"
        />
        <meta
          name="twitter:description"
          content="Celebrate Narasimha Chaturdashi 2025 with ISKCON Vijayawada! Discover the significance of Lord Narasimhadeva’s appearance, puja rituals, and how to participate in the festival."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/rathyatraDonationPage"
        />

        {/* Google Analytics tag */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-4KL8N9NL5C"
        ></script>
        <script>
          {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-4KL8N9NL5C');
    `}
        </script>

        {/* JSON-LD for WebPage */}
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Sri Jagannath Rath Yatra 2025 | ISKCON Vijayawada",
        "url": "https://www.iskconvijayawada.org/rathyatra",
        "description": "Experience the divine journey of Lord Jagannath’s Rath Yatra 2025 in Vijayawada. Join ISKCON's spiritual celebration with kirtans, prasadam, and more.",
        "publisher": {
          "@type": "Organization",
          "name": "ISKCON Vijayawada",
          "url": "https://www.iskconvijayawada.org",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.iskconvijayawada.org/static/media/RathY.55f3f04ad28fba22c824.jpeg"
          }
        }
      }
    `}
        </script>

        {/* JSON-LD for Event */}
        <script type="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "Event",
          "name": "Sri Jagannath Rath Yatra 2025",
          "startDate": "2025-07-06T08:00:00+05:30",
          "endDate": "2025-07-06T20:00:00+05:30",
          "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
          "eventStatus": "https://schema.org/EventScheduled",
          "location": {
            "@type": "Place",
            "name": "ISKCON Vijayawada",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "ISKCON Temple, Governorpet",
              "addressLocality": "Vijayawada",
              "addressRegion": "AP",
              "postalCode": "520002",
              "addressCountry": "IN"
            }
          },
          "image": [
            "https://www.iskconvijayawada.org/static/media/RathY.55f3f04ad28fba22c824.jpeg"
          ],
          "description": "Join the grand celebration of Sri Jagannath Rath Yatra 2025 organized by ISKCON Vijayawada. Experience devotional kirtans, prasadam distribution, and the spiritual chariot procession.",
          "organizer": {
            "@type": "Organization",
            "name": "ISKCON Vijayawada",
            "url": "https://www.iskconvijayawada.org"
          }
        }
      `}
        </script>
      </Helmet>

      {/* <Header /> */}
      <RathNavbar />
      <div className="ramnavami-container  ">
        <div className="ramnavami-banner  ">
          <img
            loading="lazy"
            src={rathYatraBanner}
            alt="main Img"
            className="ramnavami-banner-img md:mt-[0px]"
          />
        </div>
        <div
          className="ramnavami-content-bg md:pb-[20px] pb-1 flex justify-center flex-col items-center"
          // style={{ backgroundImage: `url(${thirdbg})` }}
        >
          <img
            src={RYMainHeading}
            alt="RYMainHeading"
            className="mt-5 md:w-[38%] w-[320px] "
          />
          <div className="ramnavami-content mt-16   ">
            <span className="flex justify-center items-center gap-4"></span>
            {/* <h2 className="ramnavami-subheadline text-center">A Grand Celebration at ISKCON Vijayawada</h2> */}
            <div className="ramnavami-text-container mb-[60px]">
              <div className="ramnavami-text-content">
                <h2 className="text-center font-bold text-[#c61d21] md:text-5xl text-3xl  bg-gradient-to-br from-orange via-red via-orange-500 to-orange text-transparent bg-clip-text ">
                  <i>A Grand Celebration at ISKCON Vijayawada</i>
                </h2>
                <br />
                <h3 className="text-[#c61d21]">
                  <b>
                    Jagannath Rath Yatra 2025 in Vijayawada – Organized by
                    ISKCON
                  </b>
                </h3>

                <p className="spacing-issue">
                  Experience the divine celebration of{" "}
                  <b> Jagannath Rath Yatra 2025</b> with{" "}
                  <a
                    className="no-underline"
                    href="https://www.iskconvijayawada.org/"
                  >
                    {" "}
                    <b>ISKCON Vijayawada</b>
                  </a>{" "}
                  Held from <b>June 27–29</b>, this is South India’s largest and
                  most devotional chariot festival. Celebrate Lord Jagannath’s
                  mercy with traditional kirtans, bhajans, and prasadam. Walk
                  alongside the Lord’s rath through the streets of Vijayawada in
                  a blissful procession. Join us for three unforgettable days of
                  spiritual joy and service!
                </p>
              </div>
            </div>
            <h2 className="ramnavami-subheadline text-center text-4xl md:text-3xl ">
              SCHEDULE ON RATH YATRA DAY (27TH JUNE)
            </h2>
            <div className="ramnavami-text-container mb-[60px] slider-SCHEDULE ">
              <div className="ramnavami-text-content rath-yatra-text-content">
                <h3 className="text-[#c61d21] text-2xl">
                  <b>INAUGURATION</b>
                </h3>
                <p className="text-xl">
                  <b>Venue</b>: Sitara Grounds, Bhavanipuram <br />
                  <b>Timings</b>: 1:00 PM to 3:00 PM <br />
                  <b>Events</b>: Cultural Programs, Pooja by Guests,
                  Inauguration of Rath Yatra by Hon CM. <br />
                </p>
                <h3 className="text-[#c61d21] text-2xl">
                  <b>RATH PROCESSION</b>
                </h3>
                <p className="text-xl">
                  <b>Timings</b>: 3:00 PM to 6:30 PM <br />
                  <b>Total Procession</b>:6 KM <br />
                  <b>Procession Route</b>: Sitara Grounds, Swathi Theatre Road,
                  Durga Temple Road, Rathm center, Seetamma vaari Paadalu.{" "}
                  <br />
                </p>
                <h3 className="text-[#c61d21] text-2xl">
                  <b>RATH YATRA ENDING (GUNDICHA)</b>
                </h3>
                <p className="text-xl">
                  <b>Venue</b>: Sitamma vaari Paadaalu Grounds, Opp Municipal
                  Corporation <br />
                  <b>Timings</b>: 6.00 PM to 9.00 PM <br />
                  <b>Events</b>: Deities entering the Pandal (Gundicha Mandir)
                  Chappan Bhog, Cutural Programs, Address by guests. <br />
                </p>
              </div>
              <div className="slider-rath-yatra cursor-pointer" ref={sliderRef}>
                <div className="with-arrows">
                  <button className="prev-button" onClick={prevSlide}>
                    <FaChevronLeft size={20} />
                  </button>
                  {SliderData.map((slide, index) => (
                    <div
                      className={`slide ${index === current ? "active" : ""}`}
                      key={index}
                    >
                      {index === current && (
                        <img
                          src={slide.img}
                          alt={`Rath Yatra slide ${index + 1}`}
                          className="slider-image"
                        />
                      )}
                    </div>
                  ))}

                  <button className="next-button" onClick={nextSlide}>
                    <FaChevronRight size={20} />
                  </button>
                </div>
              </div>
            </div>
            {/*     <h2 className="ramnavami-subheadline text-center">DAY 2 AND DAY 3 (28th - 29th JUNE)</h2>
                        <div className="ramnavami-text-container mb-[60px]">
                            <div className="ramnavami-text-content">
                                <h3 className="text-[#c61d21]"><b>RATH YATRA MELA EXHIBITION</b></h3>
                                <p> <b>Venue</b>: Sitamma vaari Paadaalu Grounds, Opp Municipal Corporation. <br />
                                    <b>Timings</b> 5:00 PM to 9:00 PM <br /> <br />
                                    •	Cultural Programs <br />
                                    •	Wonderful Kirtans & Discourses <br />
                                    •	Kids corner <br />
                                    •	Rath Pradikshanas <br />
                                    •	Delicious Dinner for all <br />
                                    •	Daily Sudarshan Yagna <br />
                                </p>
                                <h3 className="text-[#c61d21]"><b>Special Attraction: Musical Fest by devotees from 7 different countries.</b></h3>
                            </div>
                        </div> */}
          </div>
          {/* 
          <div className="xl:flex justify-between pb-4 px-4">
            <div className="xl:w-[55%] mb-8 xl:mb-0">
              <h2 className="text-3xl font-bold text-center text-[#C61D21] mb-6">
                Festival Highlights
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {eventHighlights.map((event, index) => (
                  <EventCard
                    key={index}
                    Image={event.Image}
                    title={event.title}
                    fullWidth={event.fullWidth}
                  />
                ))}
              </div>
            </div> */}

          {/* Donation Form - Right Side */}
          <div className="xl:w-[60%] xl:flex xl:justify-center xl:pt-[3.5rem] ">
            <div className="donationDetail bg-[#C61D21] py-10 px-2 rounded-3xl xl:h-full xl:p-8 xl:max-w-[1400px] w-full">
              <form onSubmit={handleSubmit} className="text-white">
                <h2 className="text-center text-2xl xl:text-4xl">
                  Donation Details
                </h2>

                <div className="innerForm sevaContainer">
                  <div>
                    <label className="block">
                      <input
                        type="checkbox"
                        name="annadaanSeva"
                        checked={formData.annadaanSeva}
                        onChange={handleInputChange}
                        style={{ accentColor: "blue" }}
                      />
                      RATH YATRA ANNDAAN SEVA
                    </label>
                    {formData.annadaanSeva && (
                      <div className="flex flex-col gap-2 mt-3 ml-4">
                        <label className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            name="isFullPlateChecked"
                            checked={formData.isFullPlateChecked}
                            onChange={handleInputChange}
                            style={{ accentColor: "blue" }}
                          />
                          <button
                            className="font-semibold py-0 px-3 bg-[#F9E7D0] rounded-md text-black text-left w-full "
                            type="button"
                            onClick={() =>
                              handleInputChange({
                                target: {
                                  name: "isFullPlateChecked",
                                  value: !formData.isFullPlateChecked,
                                },
                              })
                            }
                          >
                            FULL PLATE PRASADAM VITARANA SEVA
                          </button>
                        </label>

                        {formData.isFullPlateChecked && (
                          <div className="grid grid-cols-2 gap-2 mt-1">
                            {[
                              {
                                text: "1000 plates ₹ 60,000/-",
                                amount: 60000,
                              },
                              {
                                text: "500 plates ₹ 30,000/-",
                                amount: 30000,
                              },
                              {
                                text: "250 plates ₹ 15,000/-",
                                amount: 15000,
                              },
                              { text: "100 plates ₹ 6,000/-", amount: 6000 },
                              { text: "50 plates ₹ 3,000/-", amount: 3000 },
                            ].map((item) => (
                              <button
                                className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                                type="button"
                                key={`full-plate-${item.amount}`}
                                onClick={() =>
                                  handleAmountSelect("fullPlate", item.amount)
                                }
                                style={{
                                  backgroundColor:
                                    formData.selectedFullPlateAmount ===
                                    item.amount
                                      ? "#fac785"
                                      : "",
                                }}
                              >
                                {item.text}
                              </button>
                            ))}
                            <input
                              type="number"
                              name="customFullPlateAmount"
                              placeholder="₹ Donate as you wish"
                              value={formData.customFullPlateAmount || ""}
                              onChange={handleInputChange}
                              className="col-span-2 p-3 border rounded-xl my-1 mx-1 text-black"
                            />
                          </div>
                        )}

                        <label className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            name="isDonneCupChecked"
                            checked={formData.isDonneCupChecked}
                            onChange={handleInputChange}
                            style={{ accentColor: "blue" }}
                          />
                          <button
                            className="font-semibold py-0 px-3 bg-[#F9E7D0] rounded-md text-black text-left w-full"
                            type="button"
                            onClick={() =>
                              handleInputChange({
                                target: {
                                  name: "isDonneCupChecked",
                                  value: !formData.isDonneCupChecked,
                                },
                              })
                            }
                          >
                            DONNE/CUP PRASADAM VITARANA SEVA
                          </button>
                        </label>

                        {formData.isDonneCupChecked && (
                          <div className="grid grid-cols-2 gap-2 mt-1">
                            {[
                              { text: "2000 cups ₹ 40,000/-", amount: 40000 },
                              { text: "1000 cups ₹ 20,000/-", amount: 20000 },
                              { text: "500 cups ₹ 10,00/-", amount: 10000 },
                              { text: "300 cups ₹ 6,000/-", amount: 6000 },
                              { text: "100 cups ₹ 2,000/-", amount: 2000 },
                            ].map((item) => (
                              <button
                                className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                                type="button"
                                key={`donne-cup-${item.amount}`}
                                onClick={() =>
                                  handleAmountSelect("donneCup", item.amount)
                                }
                                style={{
                                  backgroundColor:
                                    formData.selectedDonneCupAmount ===
                                    item.amount
                                      ? "#fac785"
                                      : "",
                                }}
                              >
                                {item.text}
                              </button>
                            ))}
                            <input
                              type="number"
                              name="customDonneCupAmount"
                              placeholder="₹ Donate as you wish"
                              value={formData.customDonneCupAmount || ""}
                              onChange={handleInputChange}
                              className="col-span-2 p-3 border rounded-xl my-1 mx-1 text-black"
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <label>
                    <input
                      type="checkbox"
                      name="vastraAlankarSeva"
                      checked={formData.vastraAlankarSeva}
                      onChange={handleInputChange}
                      style={{ accentColor: "blue" }}
                    />
                    Vastra Alankar Seva
                  </label>
                  {formData.vastraAlankarSeva && (
                    <div className="grid grid-cols-2 -mt-4">
                      {[30000, 20000, 15000, 5000].map((amount) => (
                        <button
                          className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                          type="button"
                          key={amount}
                          onClick={() =>
                            handleAmountSelect("vastraAlankar", amount)
                          }
                          style={{
                            backgroundColor:
                              formData.selectedvastraAlankarAmount === amount
                                ? "#fac785"
                                : "",
                            margin: "5px",
                          }}
                        >
                          ₹ {amount.toLocaleString("en-IN")}/-
                        </button>
                      ))}
                      <input
                        type="number"
                        name="customvastraAlankarAmount"
                        placeholder="₹ Donate as you wish"
                        value={formData.customvastraAlankarAmount || ""}
                        onChange={handleInputChange}
                        className="col-span-2 p-3 border rounded-xl my-1 mx-1 customAmount text-black"
                      />
                    </div>
                  )}

                  <label>
                    <input
                      type="checkbox"
                      name="chappanBhogSeva"
                      checked={formData.chappanBhogSeva}
                      onChange={handleInputChange}
                      style={{ accentColor: "blue" }}
                    />
                    Chappan Bhog(3 days)
                  </label>
                  {formData.chappanBhogSeva && (
                    <div className="grid grid-cols-2 -mt-4">
                      {[15001].map((amount) => (
                        <button
                          className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                          type="button"
                          key={amount}
                          onClick={() =>
                            handleAmountSelect("chappanBhog", amount)
                          }
                          style={{
                            backgroundColor:
                              formData.selectedChappanBhogAmount === amount
                                ? "#fac785"
                                : "",
                            margin: "5px",
                          }}
                        >
                          ₹ {amount.toLocaleString("en-IN")}/- day
                        </button>
                      ))}
                      <input
                        type="number"
                        name="customChappanBhogAmount"
                        placeholder="₹ Donate as you wish"
                        value={formData.customChappanBhogAmount || ""}
                        onChange={handleInputChange}
                        className="col-span-2 p-3 border rounded-xl my-1 mx-1 customAmount text-black"
                      />
                    </div>
                  )}

                  <label>
                    <input
                      type="checkbox"
                      name="pushpaMalaSeva"
                      checked={formData.pushpaMalaSeva}
                      onChange={handleInputChange}
                      style={{ accentColor: "blue" }}
                    />
                    Pushpa Mala Seva(3 days)
                  </label>
                  {formData.pushpaMalaSeva && (
                    <div className="grid grid-cols-2 -mt-4">
                      {[5000].map((amount) => (
                        <button
                          className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                          type="button"
                          key={amount}
                          onClick={() =>
                            handleAmountSelect("pushpaMala", amount)
                          }
                          style={{
                            backgroundColor:
                              formData.selectedPushpaMalaAmount === amount
                                ? "#fac785"
                                : "",
                            margin: "5px",
                          }}
                        >
                          ₹ {amount.toLocaleString("en-IN")} /- day
                        </button>
                      ))}
                      <input
                        type="number"
                        name="customPushpaMalaAmount"
                        placeholder="₹ Donate as you wish"
                        value={formData.customPushpaMalaAmount || ""}
                        onChange={handleInputChange}
                        className="col-span-2 p-3 border rounded-xl my-1 mx-1 customAmount text-black"
                      />
                    </div>
                  )}

                  <label>
                    <input
                      type="checkbox"
                      name="yejnaSeva"
                      checked={formData.yejnaSeva}
                      onChange={handleInputChange}
                      style={{ accentColor: "blue" }}
                    />
                    Sudarshna Yajna Yajamana Seva
                  </label>
                  {formData.yejnaSeva && (
                    <div className="grid grid-cols-2 -mt-4">
                      {[2000].map((amount) => (
                        <button
                          className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                          type="button"
                          key={amount}
                          onClick={() => handleAmountSelect("yejna", amount)}
                          style={{
                            backgroundColor:
                              formData.selectedYejnaAmount === amount
                                ? "#fac785"
                                : "",
                            margin: "5px",
                          }}
                        >
                          ₹ {amount.toLocaleString("en-IN")} /-
                        </button>
                      ))}

                      <input
                        type="number"
                        name="customMandirAlnkarnaAmount"
                        placeholder="₹ Donate as you wish"
                        value={formData.customMandirAlnkarnaAmount || ""}
                        onChange={handleInputChange}
                        className="col-span-2 p-3 border rounded-xl my-1 mx-1 customAmount text-black"
                      />
                    </div>
                  )}
                  <label>
                    <input
                      type="checkbox"
                      name="donateByWish"
                      checked={formData.donateByWish}
                      onChange={handleInputChange}
                      style={{ accentColor: "blue" }}
                    />
                    Donate as you wish
                  </label>
                  {formData.donateByWish && (
                    <div>
                      <input
                        type="number"
                        name="customDonationAmount"
                        placeholder="₹ Donate by your wish"
                        value={formData.customDonationAmount || ""}
                        onChange={handleInputChange}
                        className="w-full p-3 border rounded-xl my-1 text-black"
                      />
                    </div>
                  )}
                </div>

                <div className="innerForm">
                  <h3 className="text-center">Personal Details</h3>
                  <label className="xl:w-full">
                    <input
                      type="text"
                      name="donorName"
                      value={formData.donorName}
                      onChange={handleInputChange}
                      placeholder="Donor Name"
                      className="mt-2"
                    />
                    {errors.donorName && (
                      <span className="block -mt-2 ml-2">
                        {errors.donorName}
                      </span>
                    )}
                  </label>
                  <label className="xl:w-full">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Email ID"
                    />
                    {errors.email && (
                      <span className="block -mt-2 ml-2">{errors.email}</span>
                    )}
                  </label>
                  <div className="flex gap-2">
                    <label className="flex-1">
                      <input
                        type="tel"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleInputChange}
                        placeholder="Mobile Number"
                        className="p-[10px] md:w-full"
                      />
                      {errors.mobile && (
                        <span className="block mt-1 ml-2">{errors.mobile}</span>
                      )}
                    </label>
                    <label className="flex-1">
                      <input
                        type="text"
                        name="dob"
                        value={formData.dob}
                        onChange={handleInputChange}
                        className="text-[#909192] p-2 border rounded-md"
                        placeholder="Date Of Birth"
                        onFocus={(e) => (e.target.type = "date")}
                        onBlur={(e) => (e.target.type = "text")}
                      />
                      {errors.dob && (
                        <span className="block -mt-2 ml-2">{errors.dob}</span>
                      )}
                    </label>
                  </div>
                </div>
                <p className="text-white mt-2 text-[10px]">
                  (Sankalpa and Archana will be performed for you on your
                  birthday)
                </p>

                <p className="text-white -mt-2 text-xs">
                  By continuing, you are agreeing to{" "}
                  <a className="underline text-[#EEF9A3]">
                    Terms of Use and Privacy Policy
                  </a>
                </p>

                <div className="px-3 tandd mt-8">
                  <label>
                    <input
                      type="checkbox"
                      name="receive80G"
                      checked={formData.receive80G}
                      onChange={handle80GCheckboxChange}
                      style={{ accentColor: "blue" }}
                    />
                    I would like to receive 80(G) Certificate
                  </label>
                  {show80GDetails && (
                    <div className="mb-3">
                      <p className="text-white text-[10px] text-left ml-2">
                        Finance Act 2021 mandates uploading donation details for
                        80(G) deductions. Ensure PAN and address details are
                        provided.
                      </p>
                      <input
                        type="text"
                        name="panNumber"
                        value={formData.panNumber}
                        onChange={handleInputChange}
                        placeholder="Pan Number *"
                        className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                        required
                      />
                      <input
                        type="text"
                        name="doorNumber"
                        placeholder="Door Number"
                        className="text-black"
                        value={formData.mahaPrasadamDetails.doorNumber}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              doorNumber: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="houseName"
                        placeholder="House / Apartment / Building Name"
                        value={formData.mahaPrasadamDetails.houseName}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              houseName: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="streetName"
                        placeholder="Street Name"
                        value={formData.mahaPrasadamDetails.streetName}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              streetName: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="area"
                        placeholder="Location / Area"
                        value={formData.mahaPrasadamDetails.area}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              area: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="country"
                        placeholder="Country"
                        value={formData.mahaPrasadamDetails.country}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              country: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="state"
                        placeholder="State"
                        value={formData.mahaPrasadamDetails.state}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              state: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="city"
                        placeholder="City"
                        value={formData.mahaPrasadamDetails.city}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              city: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="pincode"
                        placeholder="Pincode"
                        value={formData.mahaPrasadamDetails.pincode}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              pincode: e.target.value,
                            },
                          }))
                        }
                      />
                    </div>
                  )}

                  <label>
                    <input
                      type="checkbox"
                      name="receiveMahaPrasadam"
                      checked={formData.receiveMahaPrasadam}
                      onChange={handleMahaPrasadamCheckboxChange}
                      style={{ accentColor: "blue" }}
                    />
                    I would like to receive Maha prasadam (Only within India)
                  </label>
                  {showMahaPrasadamDetails && (
                    <div className="mt-3">
                      <input
                        type="text"
                        name="doorNumber"
                        placeholder="Door Number"
                        className="text-black"
                        value={formData.mahaPrasadamDetails.doorNumber}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              doorNumber: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="houseName"
                        placeholder="House / Apartment / Building Name"
                        value={formData.mahaPrasadamDetails.houseName}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              houseName: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="streetName"
                        placeholder="Street Name"
                        value={formData.mahaPrasadamDetails.streetName}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              streetName: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="area"
                        placeholder="Location / Area"
                        value={formData.mahaPrasadamDetails.area}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              area: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="country"
                        placeholder="Country"
                        value={formData.mahaPrasadamDetails.country}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              country: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="state"
                        placeholder="State"
                        value={formData.mahaPrasadamDetails.state}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              state: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="city"
                        placeholder="City"
                        value={formData.mahaPrasadamDetails.city}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              city: e.target.value,
                            },
                          }))
                        }
                      />
                      <input
                        type="text"
                        className="text-black"
                        name="pincode"
                        placeholder="Pincode"
                        value={formData.mahaPrasadamDetails.pincode}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            mahaPrasadamDetails: {
                              ...prev.mahaPrasadamDetails,
                              pincode: e.target.value,
                            },
                          }))
                        }
                      />
                    </div>
                  )}
                </div>

                <div className="flex justify-center mt-8">
                  <button
                    type="submit"
                    className="bg-[#FAE29C] text-black px-12 py-3 rounded-2xl font-bold"
                  >
                    Donate{" "}
                    {getTotalAmount() > 0
                      ? "₹ " + getTotalAmount().toLocaleString("en-IN")
                      : ""}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* <div className="mx-2 mt-4 md:mt-0">
                        <div className="text-left md:mx-44 pb-10">
                            <h2 className="text-3xl  text-[#C61D21] text-left font-bold">
                                Note:
                            </h2>
                            <p className="md:text-2xl  text-base text-black w-full text-justify font-semibold">
                                Donors contributing <span className="text-red"> ₹2,116 </span>
                                or more will be specially invited to sit in the sacred Sri
                                Sudarshana Narasimha Maha Yajna — with options to participate
                                both onsite at the temple or virtually from home
                            </p>
                        </div>
                    </div> */}

        {/* donation Through Bank */}
        <div className="mx-2 md:mt-20 mt-12 md:w-[99%] w-[96%]">
          <div className="md:mx-44  md:border-5 border-2 md:rounded-2xl rounded-lg border-[#C61D21] mt-1 justify-center items-center  overflow-hidden">
            <h2 className="md:py-4 py-3 bg-[#C61D21] text-white text-center md:text-3xl text-base">
              Donation Through Bank (NEFT/RTGS){" "}
            </h2>
            <div className="flex justify-center items-center">
              <ul className="flex flex-col justify-center items-center leading-4 space-y-4 list-none px-0 mx-0  my-2">
                <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                  <span className="md:text-2xl text-[15px] text-[#C61D21] ">
                    Bank Name:<span className="text-black"> HDFC Bank</span>
                  </span>{" "}
                  <button
                    class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                    onClick={() => copyToClipboard("HDFC Bank", "bankName")}
                  >
                    {copiedText === "bankName" ? "Copied!" : "Copy"}
                  </button>
                </li>

                <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                  <span className="md:text-2xl text-[15px] text-[#C61D21]">
                    Account Name:<span className="text-black"> ISKCON</span>
                  </span>{" "}
                  <button
                    class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5  border-1 border-[#C61D21] ml-2 rounded-full"
                    onClick={() => copyToClipboard("ISKCON", "accountName")}
                  >
                    {copiedText === "accountName" ? "Copied!" : "Copy"}
                  </button>
                </li>
                <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                  <span className=" text-[#C61D21]">
                    Account Number:{" "}
                    <span className="text-black">50100436709020</span>
                  </span>{" "}
                  <button
                    class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                    onClick={() =>
                      copyToClipboard("50100436709020", "accountNumber")
                    }
                  >
                    {copiedText === "accountNumber" ? "Copied!" : "Copy"}
                  </button>
                </li>
                <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal ">
                  <span className=" text-[#C61D21]">
                    IFSC Code: <span className="text-black">HDFC000568</span>
                  </span>
                  <button
                    class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                    onClick={() => copyToClipboard("HDFC000568", "ifscCode")}
                  >
                    {copiedText === "ifscCode" ? "Copied!" : "Copy"}
                  </button>
                </li>
                <li className="w-full md:text-2xl text-[15px] leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                  <span className=" text-[#C61D21]">
                    Branch:{" "}
                    <span className="text-black">ONE TOWN VIJAYAWADA </span>
                  </span>{" "}
                  <button
                    class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                    onClick={() =>
                      copyToClipboard("ONE TOWN VIJAYAWADA", "branch")
                    }
                  >
                    {copiedText === "branch" ? "Copied!" : "Copy"}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* UPI Payment */}
        <div className="mx-2 ">
          <div className="md:mx-44  md:border-5 border-2 md:rounded-2xl rounded-lg border-[#C61D21] mt-10 overflow-hidden">
            <h2 className="md:py-4 py-2 bg-[#C61D21] text-white text-center md:text-3xl text-base">
              Donate Through UPI
            </h2>

            <div className="flex md:flex-row flex-col justify-around items-center pt-3 md:pb-3 pb-4 gap-4">
              <div className="md:block flex gap-2 px-1">
                <h2 className="md:text-2xl text-sm text-[#C61D21]">UPI ID:</h2>
                <p className="md:text-xl text-sm  text-black">
                  {" "}
                  ISCKONVIJAYAWADA@IDFCBANK
                </p>
              </div>
              <img
                loading="lazy"
                src={barcode1}
                alt=""
                width="200px"
                height="200px"
              />
              <span className="font-bold">OR</span>
              <img
                loading="lazy"
                src={barcode2}
                alt=""
                width="200px"
                height="200px"
              />
            </div>
          </div>

          <div className="text-left md:mx-44 mt-5 pb-10">
            <h2 className="text-3xl  text-[#C61D21] text-left font-bold">
              After Donation:
            </h2>
            <p className="md:text-2xl mt-4 text-base text-black w-full text-justify font-semibold">
              Once you have donated, please share the transaction details or
              receipt via WhatsApp at{" "}
              <span className="text-red">+91 9955685568</span>. This helps us
              acknowledge your contribution and issue a receipt for tax
              exemption under Section 80G of the Income Tax Act.
            </p>

            <h3 class="text-3xl font-bold mb-0 text-center  text-red mt-8">
              Rath Yatra Registrations
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10">
              <div class="bg-white border-3 border-orange rounded-lg shadow-md overflow-hidden hover:shadow-xl  transition-all duration-300">
                <div class="overflow-hidden">
                  <img
                    src={beAvolenter}
                    alt="Volunteer"
                    class="w-full h-[240px] object-cover transition-transform duration-300 hover:scale-105"
                  />
                </div>
                <div class="p-4">
                  <p class="text-red-500 text-bold mb-4 text-center">
                    Be A volunteer
                  </p>
                  <div class="flex justify-center">
                    <a
                      href="https://forms.gle/DhTV7XLFK4gXLT6y6"
                      class="bg-red hover:bg-rose-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline no-underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Register Now
                    </a>
                  </div>
                </div>
              </div>
              <div class="bg-white border-3 border-orange rounded-lg shadow-md overflow-hidden hover:shadow-xl  transition-all duration-300">
                <div class="overflow-hidden">
                  <img
                    src={chappanBhog}
                    alt="Offer Bhoga"
                    class="w-full h-[80%] object-cover transition-transform duration-300 hover:scale-105"
                  />
                </div>
                <div class="p-4">
                  <p class="text-red-500 text-bold mb-4 text-center">
                    Offer bhoga to jagganath
                  </p>
                  <div class="flex justify-center">
                    <a
                      href="https://forms.gle/bQPYgh2y1wo6UcW77"
                      class="bg-red hover:bg-rose-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline no-underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Register Now
                    </a>
                  </div>
                </div>
              </div>
              <div class="bg-white border-3 border-orange rounded-lg shadow-md overflow-hidden hover:shadow-xl  transition-all duration-300">
                <div class="overflow-hidden">
                  <img
                    src={marchandise}
                    alt="Merchandise Request"
                    class="w-full h-[240px] object-cover transition-transform duration-300 hover:scale-105"
                  />
                </div>
                <div class="p-4 ">
                  <p class="text-red-500 text-bold mb-4 text-center ">
                    Merchandise Request Registration
                  </p>
                  <div class="flex justify-center">
                    <a
                      href="http://forms.gle/bvKfR9EeD41Qn8Pi8"
                      class="bg-red hover:bg-rose-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline no-underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Register Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="ramnavami-text-container pb-[150px]  ">
                            <div className="ramnavami-text-content ">
                                <h2 className="ramnavami-subheadline text-center">Rath Yatra Registrations </h2>
                              
                            </div>
                        </div> */}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default RathYatraPage;
